<template>
  <div class="top_box dis_f fle_t">
          <img
        src="@/assets/img/audio_open.png"
        v-if="$store.state.audioPlay"
        class="contro_audio active right"
        @click="$store.commit('setAudioPlay',false)"
        alt
      >
      <img
        src="@/assets/img/audio_close.png"
        @click="$store.commit('setAudioPlay',true)"
        v-else
        class="contro_audio right"
        alt
      >
    <div class="test_list fle_no" :class="{'active':testData[3]==0}" @click="tagChange(0)">
      <img src="@/assets/img/test_four1.png" class="list_txt" alt>
    </div>
    <div class="test_list fle_no" :class="{'active':testData[3]==1}" @click="tagChange(1)">
      <img src="@/assets/img/test_four2.png" class="list_txt" alt>
    </div>
    <div class="test_list fle_no" :class="{'active':testData[3]==2}" @click="tagChange(2)">
      <img src="@/assets/img/test_four3.png" class="list_txt" alt>
    </div>
    <div class="test_list fle_no" :class="{'active':testData[3]==3}" @click="tagChange(3)">
      <img src="@/assets/img/test_four4.png" class="list_txt" alt>
    </div>
    <div class="fl1"></div>
    <img
      src="@/assets/img/send_btn.png"
      data-name="完成测试"
      @click="openPage"
      class="test_btn fle_no"
      alt
    >
    <div class="b_box dis_f ali_ct jus_ct" v-show="showLoad">
      <div class="loading_box"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      showLoad: false
    };
  },
  computed: {
    ...mapState(["testData"])
  },
  methods: {
    tagChange(num) {
      const data = JSON.parse(JSON.stringify(this.$store.state.testData));
      data[3] = num;
      this.$store.commit("setStoreData", {
        name: "testData",
        data: data
      });
    },
    openPage() {
      if (typeof this.testData[3] == "undefined") {
        this.$toast("请选择选项");
        return;
      }
      this.axios.post(
        "http://wine.koyooo.com/phone/saveAnswer.html",
        "answer=" + this.testData.toString()
      );
      this.showLoad = true;
      setTimeout(() => {
        this.showLoad = false;
        this.$router.replace({ name: "testResult" });
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.top_box {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  background: url("~@/assets/img/four_bg.png") no-repeat left 30px;
  background-size: 720px auto;
  padding-top: 117px;
  .test_list {
    position: relative;
    height: 115px;
    &.active::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -18px;
      transform: translateX(-25%);
      width: 114px;
      height: 32px;
      background: url("~@/assets/img/test_checked.png") no-repeat center;
      background-size: cover;
    }
    &:nth-of-type(1) {
      margin-left: 30px;
      margin-bottom: 186px;
      &::before {
        left: 40px;
      }
    }
    &:nth-of-type(2) {
      margin-left: 136px;
      margin-bottom: 82px;
      &::before {
        left: 30px;
      }
    }
    &:nth-of-type(3) {
      margin-left: 0px;
      margin-bottom: 148px;
      height: 106px;
      &::before {
        left: 60px;
      }
    }
    &:nth-of-type(4) {
      margin-left: 65px;
      height: 110px;
      margin-bottom: 80px;
      &::before {
        left: 20px;
      }
    }
    .list_txt {
      height: 100%;
    }
  }
}
.loading_box {
  width: 581px;
  height: 429px;
  background: #0d0000 url("~@/assets/img/get_wine.gif") no-repeat center;
  background-size: cover;
  border: solid 5px #f00000;
}
</style>
